import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FinanceService } from 'src/modules/features/contractor/services';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-official-equipment-row',
  templateUrl: './official-equipment-row.component.html',
  styleUrls: ['./official-equipment-row.component.scss'],
})
export class OfficialEquipmentRowComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  @Input() equipment: any;
  @Input() equipmentTypes: any;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  arrangements: Array<any> = [];
  error: any;
  collapseEquipment: boolean = true;
  @Output() onRestoreModal: EventEmitter<any> = new EventEmitter();
  @Output() editEquipment: EventEmitter<any> = new EventEmitter();
  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private financeSvc: FinanceService
  ) {}
  goBack() {}
  getEquipmentTypeName(id) {
    var type = this.equipmentTypes.find((type) => type.optionId == id);
    return type.optionName;
  }
  toggleEquipment() {
    this.collapseEquipment = !this.collapseEquipment;
  }
  searchRecords(event) {}
  displayRecords(event) {}
  sortRecords(event) {}
  nextPage(event) {}
  viewProject(event) {}
  ngOnInit(): void {}
}
